import axios from 'axios';
import { API, authHeaders } from '../admin/adminApi';

export async function uploadBuilderImage(file) {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await axios.post(`${API}/api/admin/uploads/image`, fd, { headers: { ...authHeaders() } });
  return data.url; // e.g. /api/uploads/media/<id>
}

// Convert a possibly-relative image url to an absolute one for <img src>.
export const resolveUrl = (u) => {
  if (!u) return u;
  if (u.startsWith('/api/')) return `${API}${u}`;
  return u;
};

export async function getPageAdmin(pageKey) {
  const { data } = await axios.get(`${API}/api/admin/page-builder/${pageKey}`, { headers: authHeaders() });
  return data;
}
export async function savePageDraft(pageKey, sections) {
  const { data } = await axios.put(`${API}/api/admin/page-builder/${pageKey}/draft`, { sections }, { headers: authHeaders() });
  return data;
}
export async function publishPage(pageKey) {
  const { data } = await axios.post(`${API}/api/admin/page-builder/${pageKey}/publish`, {}, { headers: authHeaders() });
  return data;
}
export async function resetPage(pageKey) {
  const { data } = await axios.post(`${API}/api/admin/page-builder/${pageKey}/reset`, {}, { headers: authHeaders() });
  return data;
}
